<template>
  <div class="tabBar">
    <van-tabbar
      v-model="newActive"
      active-color="#0245bf"
      inactive-color="#000"
      @change="changeTab"
    >
      <van-tabbar-item
        v-for="(item,index) in items"
        :key="index"
        :to="item.path ? item.path : item.url"
        :replace="item.replace"
      >
        <span>{{item.name}}</span>
        <img slot="icon" slot-scope="props" :src="props.active ? item.activeIcon : item.normalIcon" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "TabBar",
  props: {
    active: Number
  },
  data() {
    return {
      newActive: "",
      items: [
        {
          name: "首页",
          path: "/home",
          normalIcon: require("../../image/house.png"),
          activeIcon: require("../../image/house_c.png"),
          replace: false
        },
        {
          name: "扫码核销",
          url: "",
          normalIcon: require("../../image/saoma.png"),
          activeIcon: require("../../image/saoma_c.png"),
          replace: false
        },
        {
          name: "我的",
          path: "/mine/shop",
          normalIcon: require("../../image/me.png"),
          activeIcon: require("../../image/me_c.png"),
          replace: false
        }
      ]
    };
  },
  mounted() {
    this.$wechartfunc();
    this.newActive = this.active;
  },
  methods: {
    async changeTab(newActive) {
      // console.log(newActive);
      if (newActive == 1) {
        const scanQRCode = await this.$wechartfunc("scanQRCode");
        if (scanQRCode) {
          this.$router.push({
            path: `/couponVerification/searchDetail`,
            query: {
              sancode: scanQRCode
            }
          });
        }
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.icons {
  .van-swipe {
    padding: px2rem(40);
    .icon {
      float: left;
      width: 22%;
      height: px2rrem(240);
      padding-top: px2rem(25);
      text-align: center;
      .icon-img {
        width: px2rem(100);
        height: px2rem(100);
        display: inline-block;
        img {
          border-radius: 50%;
        }
        .img-content {
          width: px2rem(100);
          height: px2rem(100);
          background: 0;
        }
      }
      ::v-deep .van-tabbar-item__icon img {
        height: 1.3rem !important;
      }
      .keywords {
        margin: px2rem(20) 0;
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: px2rem(28);
      }
    }
  }
}
</style>